import React from 'react'

function NoRecords() {
    return (
        <div style={{
            height: '70vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }}><img alt='kmkcd' src='https://www.rajasthanndaacademy.com/assets/images/no-record-found.png' width={200} /></div>
    )
}

export default NoRecords